import { graphql } from 'react-relay';

export const createDrawingSetAnnotationMutation = graphql`
    mutation createDrawingSetAnnotationMutation($input: DrawingSetAnnotationCreateInput!) {
        createDrawingSetAnnotation(input: $input) {
            cursor
            node {
                ...drawingSetAnnotationFragment
            }
        }
    }
`;
